<!-- 巡检同期对比 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <Echart ref="option" :options="option" style="height: 100%"></Echart>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts/lib/echarts';
  import {
    postAction
  } from '@/api/manage'
  export default {
    data() {
      return {
        title: this.$t('巡检同期对比'),
        url: {
          LargeScreenTwoYearsIncreaseInspection: "/jeecg-engineering/inspection/inspectionTask/LargeScreenTwoYearsIncreaseInspection"
        },
        option: {},
      }
    },
    mounted() {},
    methods: {
      init() {
        this.getData();
      },
      getData(){
        postAction(this.url.LargeScreenTwoYearsIncreaseInspection,{planType:1}).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption(data);
          }
        })
      },
      setOption(data) {
        let seriesData = []
        let y1 = [];
        let y2 = [];
        let xData = [];
        data.map(item=>{
          y1.push(item.lastYearNum);
          y2.push(item.thisYearNum);
          xData.push(item.time);
        });
        seriesData[0] = {
          name: this.$t('去年'),
          type: 'bar',
          barMaxWidth: 14,
          stack: 'sum',
          smooth: true,
          symbol: "none",
          animationDelay: (0 * 200) - 100,
          animationDuration: 300,
          data: y1
        }
        seriesData[1] = {
          name: this.$t('今年'),
          type: 'bar',
          barMaxWidth: 14,
          barGap: "10%",
          stack: 'sum1',
          smooth: true,
          symbol: "none",
          animationDelay: (0 * 200) - 100,
          animationDuration: 300,
          data: y2
        }
        this.$refs.option.hideLoading()
        this.option = {
          color: ['#50E3C2','#0394FF'],
          title: {
            show: false
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            },
            // formatter: '{a0}: {c0}<br/>{a1}: {c1}'
          },
          legend: {
            type: 'scroll',
            data: [this.$t('去年'), this.$t('今年')],
            textStyle: {
              color: '#CEE2FF'
            },
            // icon: 'circle',
            itemHeight: 10,
            right: 0,
            // pageIconColor: '#aaa',
            // pageIconInactiveColor: '#2f4554',
            // pageTextStyle: {
            //   color: 'rgb(91, 135, 195)'
            // }
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: xData,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: ['#074671'],
              }
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          },
          yAxis: [
            {
              type: 'value',
              name: this.$t('单位:次'),
              nameTextStyle: {
                color: '#D1F3FF',
                align: 'center',
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dotted',
                  color: ['#074671'],
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: '#D1F3FF',
                fontSize: 10
              }
            },
          ],
          series: seriesData
        };
      },
      // setOption() {
      //   var chartDom = document.getElementById('chart');
      //   var myChart = echarts.init(chartDom);
      //   var option = {
      //     textStyle: {
      //       color: '#fff'
      //     },
      //     grid: {
      //       bottom: '10%'
      //     },
      //     tooltip: {
      //       trigger: 'axis',
      //       axisPointer: {
      //         type: 'cross',
      //         crossStyle: {
      //           color: '#fff'
      //         }
      //       }
      //     },
      //     legend: {
      //       top: '3%',
      //       left: '3%',
      //       textStyle: {
      //         color: '#fff'
      //       },
      //     },
      //     xAxis: [{
      //       type: 'category',
      //       data: ['04月','05月','06月'],
      //       axisPointer: {
      //         type: 'shadow'
      //       },
      //     }],
      //     yAxis: [{
      //         type: 'value',
      //         axisLabel: {
      //           formatter: '{value}'
      //         }
      //       },
      //       {
      //         type: 'value',
      //         axisLabel: {
      //           formatter: '{value} %'
      //         }
      //       }
      //     ],
      //     series: [{
      //         name: '工单总数',
      //         type: 'bar',
      //         tooltip: {
      //           valueFormatter: function(value) {
      //             return value + ' ml';
      //           }
      //         },
      //         data: [20,33,44],
      //         barWidth: 20,
      //         itemStyle: {
      //           normal: {
      //             color: '#3BA1FF',
      //             barBorderRadius: [5, 5, 0, 0]
      //           }

      //         }
      //       },
      //       {
      //         name: '完结(%)',
      //         type: 'line',
      //         yAxisIndex: 1,
      //         tooltip: {
      //           valueFormatter: function(value) {
      //             return value + ' °C';
      //           }
      //         },
      //         data: [11,23,34],
      //         itemStyle: {
      //           color: '#FF9898'
      //         }
      //       }
      //     ]
      //   }
      //   option && myChart.setOption(option);
      // }
    },
  }
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    position: absolute;
    right: 0;
  }

  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .trends-box {}

  .ant-radio-button-wrapper {
    color: #fff;
    background: transparent;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #1890FF;
  }
</style>